import { style, animate, transition, query, stagger, trigger } from '@angular/animations';

export const fadeIn = (selector = ':enter', duration = '400ms ease-out') => [
  transition('* => *', [
    query(
      selector,
      [
        style({ opacity: 0, transform: 'translateY(-5px)' }),
        stagger('60ms', [
          animate(
            duration,
            style({
              opacity: 1,
              transform: 'translateY(0px)',
            })
          ),
        ]),
      ],
      { optional: true }
    ),
  ]),
];

export const fadeOut = (selector = ':leave', duration = 300) => [
  transition('* => *', [
    query(
      selector,
      [
        style({ opacity: 1 }),
        stagger('30ms', [
          animate(
            duration,
            style({
              opacity: 0,
            })
          ),
        ]),
      ],
      { optional: true }
    ),
  ]),
];

export const fadeInOut = trigger('inOutAnimation', [
  transition(':enter', [
    style({ display: 'initial', opacity: 0 }),
    animate('.3s .3s ease-in', style({ display: 'block', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ display: 'none', opacity: 1 }),
    animate('.3s .3s ease-out', style({ display: 'hidden', opacity: 0 })),
  ]),
]);
